export const platformStats = [
  {
    name: "courses",
    value: 100,
    label: "<b>Courses</b> on our platform",
  },
  {
    name: "students",
    value: 4465,
    label: "<b>Students</b> for today",
  },
  {
    name: "score",
    value: 184,
    label: "<b>Average</b> score of our students",
  },
  {
    name: "certificates",
    value: 3208,
    label: "<b>Certificates</b> issued",
  },
];
